import styled from 'styled-components';
import { Link } from '../common';
import { Colors } from '../utils/colors';

export const Hyper = styled(Link)`
    color: ${Colors.trueWhite};
`;

export const Group = styled.div`
    margin-top: 20px;
`;

export const Basket = styled.div`
    margin-top: 20px;
`;

export const DinnerContainer = styled.article`
    min-height: 613px;
    align-self: end;
`;